import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import Typography from 'components/Text/Text';
import { AspectRatio } from 'utils/sharedStrapiQueries/sharedTypes';
import { mediaDesktop } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

const handleAspectRatio = (aspectRatio: AspectRatio) => {
  switch (aspectRatio) {
    case '_1x1':
      return css`
        aspect-ratio: 1 / 1;
      `;
    case '_2x3':
      return css`
        aspect-ratio: 2 / 3;
      `;
    case '_4x5':
      return css`
        aspect-ratio: 4 / 5;
      `;
    case '_5x4':
      return css`
        aspect-ratio: 5 / 4;
      `;
    case '_6x4':
      return css`
        aspect-ratio: 6 / 4;
      `;
    case '_16x9':
      return css`
        aspect-ratio: 16 / 9;
      `;
    case 'default':
      return css`
        aspect-ratio: auto;
      `;
    default:
      return css`
        aspect-ratio: auto;
      `;
  }
};

export const Heading = styled(Typography)<{ textColor?: string }>`
  display: inline;
  font-weight: 135;

  width: calc(100%);
  background-image: ${({ textColor }) =>
    `linear-gradient(transparent calc(100% - 2px), ${
      colors[textColor] ?? textColor ?? 'white'
    } 22px)`};
  background-repeat: no-repeat;
  background-size: 0 100%;
  background-position: 100% 100%;
  transition: background-size 500ms, color 500ms;

  &:hover {
  }
`;

export const InsightsTileWrapper = styled(motion.div)<{ textColor?: string }>`
  cursor: pointer;
  position: relative;
  width: 100%;
  z-index: 1;

  &:hover {
    ${Heading} {
      background-size: 100% 100%;
      background-position: 0 100%;

      ${({ textColor }) =>
        textColor?.length && `color: ${colors[textColor] ?? textColor}`};
    }
  }
`;

export const MediaContainer = styled.div<{ aspectRatio: AspectRatio }>`
  width: 100%;
  ${({ aspectRatio }) => handleAspectRatio(aspectRatio)};
`;

export const Image = styled.img`
  pointer-events: none;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Video = styled.video`
  width: 100%;
  height: 100%;
  pointer-events: none;
  display: block;
  object-fit: cover;
`;

export const TextContainer = styled.div`
  padding-right: 20px;
`;

export const BottomTextContainer = styled.div`
  margin: 16px 0;
  display: grid;
  grid-template-columns: 1fr;
  grid-area: text;
  row-gap: 8px;

  ${mediaDesktop(css`
    row-gap: 12px;
  `)}
`;

export const Title = styled(Typography)`
  margin-bottom: 10px;
`;

export const Description = styled(Typography)`
  color: #8f8f8f;
`;

export const Date = styled(Typography)`
  padding-top: 4px;
  color: #8f8f8f;

  ${mediaDesktop(css`
    padding-top: 8px;
  `)}
`;

export const Tag = styled(Typography)`
  color: ${({ theme }) => theme.colors.white};
`;
